import {
  Alignment,
  Icon,
  Menu,
  MenuItem,
  Navbar,
  NavbarDivider,
  NavbarGroup,
  Popover,
} from '@blueprintjs/core';
import { useViewportSizer } from 'Data/context/ViewportSizer';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';
import styles from './TopNavMenuBar.module.css';

const TopNavMenuBar = ({
  homeButton,
  leftMenuItems,
  rightMenuItems,
  userAccountMenuItems,
  helpMenuItem,
  userName,
  darkMode = false,
}) => {
  const { narrowScreen } = useViewportSizer();
  const getNavButtonForItem = (item, index) => {
    return (
      <NavLink
        key={index}
        className={({ isActive }) =>
          isActive
            ? darkMode
              ? styles.nav_selected_dark
              : styles.nav_selected
            : darkMode
            ? styles.nav_button_dark
            : styles.nav_button
        }
        to={item.to}
        onMouseDown={(e) => e.preventDefault()}>
        {item.title}
      </NavLink>
    );
  };

  let menuItems = leftMenuItems.map((item, index) => {
    // if Authorized
    return getNavButtonForItem(item, index);
  });

  let moreButton = helpMenuItem && (
    <Popover
      className={styles.nav_more_menu_button}
      minimal
      placement='bottom-end'
      content={
        <Menu>
          {
            <MenuItem
              icon={helpMenuItem.icon}
              text={helpMenuItem.text}
              href={helpMenuItem.href}
              target={helpMenuItem.target || '_self'}
            />
          }
        </Menu>
      }
      inheritDarkTheme={false}>
      <Icon icon='more' style={{ transform: 'rotate(90deg)' }} />
    </Popover>
  );

  let rightMenuContent =
    rightMenuItems &&
    rightMenuItems.map((item, index) => {
      if (item.menuItems?.length) {
        let subMenuItems = [];
        subMenuItems = item.menuItems.map((subItem, subIndex) => {
          return (
            <MenuItem
              key={subIndex}
              icon={subItem.icon}
              text={subItem.text}
              href={subItem.href}
              target={subItem.target || '_self'}
            />
          );
        });
        let subMenu = <Menu>{subMenuItems}</Menu>;
        return (
          <Popover
            minimal
            key={index}
            placement='bottom-end'
            content={subMenu}
            inheritDarkTheme={false}>
            <Icon icon={item.icon} />
          </Popover>
        );
      }
      // else no sub menu
      return getNavButtonForItem(item, index);
    });

  let welcomeText = userName && (
    <span className={styles.welcome_text}>{`Welcome ${
      userName.split(' ')[0]
    }`}</span>
  );

  let userAccountMenu = userAccountMenuItems && (
    <Menu>
      {userAccountMenuItems.map((item, index) => {
        return (
          <MenuItem
            key={index}
            icon={item.icon}
            text={item.text}
            href={item.href}
            target={item.target || '_self'}
          />
        );
      })}
    </Menu>
  );

  let userTag = userName && (
    <div className={styles.avatar_circle}>
      {userName.charAt(0).toUpperCase()}
    </div>
  );

  let userMenuButton = userAccountMenuItems && (
    <Popover
      className={styles.nav_more_menu_button}
      minimal
      placement='bottom-end'
      content={userAccountMenu}
      inheritDarkTheme={false}>
      <>
        {!narrowScreen && welcomeText}
        {userTag}
        <Icon className={styles.chevron_icon} icon={'chevron-down'} />
      </>
    </Popover>
  );

  return (
    <Navbar className={darkMode ? styles.top_nav_dark : styles.top_nav_light}>
      <NavbarGroup>
        {homeButton}
        {homeButton && menuItems.length > 0 && (
          <NavbarDivider className={styles.divider} />
        )}
        {menuItems}
      </NavbarGroup>
      <NavbarGroup className={styles.nav_right_group} align={Alignment.RIGHT}>
        {userMenuButton}
        {rightMenuContent}
        {moreButton}
      </NavbarGroup>
    </Navbar>
  );
};

TopNavMenuBar.propTypes = {
  homeButton: PropTypes.element,
  leftMenuItems: PropTypes.array,
  rightMenuItems: PropTypes.array,
  userAccountMenuItems: PropTypes.array,
  locationToTabIdMap: PropTypes.object,
  helpMenuItem: PropTypes.object,
  location: PropTypes.object,
  userName: PropTypes.string,
  darkMode: PropTypes.bool,
};

export default TopNavMenuBar;
